import api from "./baseapi";
import { ApiResponse } from "./api.response";

export const http = {
  get,
  post,
  logout,
  update,
  remove,
};

function get(routeUrl, isToken) {
  return new Promise((resolve) => {
    return api
      .get(routeUrl, { headers: getHeaders(isToken) })
      .then((res) => {
        resolve(res.data);
      })
      .catch(function (err) {
        try {
          if (err.response.status === 401) {
            logout();
          }
          resolve(
            ApiResponse(false, err.response.data.message, false, err.code, 0)
          );
        } catch (commonerror) {
          resolve(ApiResponse(false, err.message, false, err.code, 0));
        }
      });
  });
}

function post(routeUrl, data, isToken) {
  const isFormData = data instanceof FormData;
  return new Promise((resolve) => {
    return api
      .post(routeUrl, data, { headers: getHeaders(isToken, isFormData) })
      .then((res) => {
        resolve(res.data);
      })
      .catch(function (err) {
        try {
          if (err.response.status === 401) {
            logout();
          }
          resolve(
            ApiResponse(false, err.response.data.message, false, err.code, 0)
          );
        } catch (commonerror) {
          resolve(ApiResponse(false, err.message, false, err.code, 0));
        }
      });
  });
}

function update(routeUrl, formdata, isToken) {
  return new Promise((resolve) => {
    return api
      .patch(routeUrl, formdata, { headers: getHeaders(isToken) })
      .then((res) => {
        resolve(res.data);
      })
      .catch(function (err) {
        try {
          if (err.response.status === 401) {
            logout();
          }
          resolve(
            ApiResponse(false, err.response.data.message, false, err.code, 0)
          );
        } catch (commonerror) {
          resolve(ApiResponse(false, err.message, false, err.code, 0));
        }
      });
  });
}

function remove(routeUrl, isToken) {
  return new Promise((resolve) => {
    return api
      .delete(routeUrl, { headers: getHeaders(isToken) })
      .then((res) => {
        resolve(res.data);
      })
      .catch(function (err) {
        try {
          resolve(
            ApiResponse(false, err.response.data.message, false, err.code, 0)
          );
        } catch (commonerror) {
          resolve(ApiResponse(false, err.message, false, err.code, 0));
        }
      });
  });
}

function logout() {
  localStorage.removeItem("token");
  window.location.replace("/");
}

function getHeaders(boolToken, isFormData = false) {
  if (boolToken) {
    const userdata = localStorage.getItem("token");

    if (!userdata) {
      window.location = "/";
      return;
    }

    const headers = {
      Accept: "application/json",
      Authorization: `Bearer ${userdata}`,
    };

    // Let the browser set Content-Type (with boundary) for FormData.
    // Only force it for JSON payloads.
    if (!isFormData) {
      headers["Content-Type"] = "application/json; charset=utf-8";
    }

    return headers;
  }
}